import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem, Icon } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout } from "@blueprintjs/core";
import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation,ProgressBar} from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import {CBBCTranInfo,  StkCodeInfo, CurrencyInfo ,sbConfig} from './Types'
import { SystemHeader } from './CommonUI';

import i18next from 'i18next';
import { useStrictMode } from 'react-konva';
import GsbxConfigMain from './GsbxConfig';
import { copyFile } from 'fs';
import { useHistory } from "react-router-dom";

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

interface PageInfo {
    n: number
}

var GsbFlag: any;

interface CBBCCallMgntViewProps {
    gsb: AxiosInstance,
    CBBCTran: CBBCTranInfo,
    CBBCTran0: CBBCTranInfo,    
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
}
 

interface TaskInfo {
    id: string,
    ref: string,
    description: string,
    startTime: string,
    endTime: string,
    userId: string,
    progressValue: number,
    progressMax: number,
    status: number,
    message: string,
    logFile: string
}



interface CBBCStockHolderListProps {
    gsb: AxiosInstance,
    CBBC: CBBCTranInfo,
    baseUrl?: string,
    token?: string | null,
   
    ViewMode: any,
    logKey2: any,
}

interface RptRstInfo {
    Rst_Key: string,
    Rst_Line: string,
}

 //CBBCStockHolderList
function  CBBCStockHolderList({ gsb, CBBC = {} as CBBCTranInfo, baseUrl = "", token = "",   ViewMode, logKey2 }: CBBCStockHolderListProps) {
 
    let ProgressId2 = ""

    const [taskList, setTaskList] = useState([] as TaskInfo[])
    const [showTasks, setShowTasks] = useState(false)
    const [ImportGSBMsg, setImportGSBMsg] = useState("")    
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme1") 
    const [isReplicate, setisReplicate] = useState(false)
    const [isRegenbcan, setisRegenbcan] = useState(false)

    const { t, i18n } = useTranslation();

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
 

    const [AcName1Value, setAcName1Value] = useState("")
    const [AcName2Value, setAcName2Value] = useState("")
    const [AcStatusValue, setAcStatusValue] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    const [ProgressId, setProgressId] = useState("")
    const [ProgressValue, setProgressValue] = useState(0)

    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptHead2, setRptHead2] = useState("")
    const [RptName, setRptName] = useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [ShowWait, setShowWait] = useState(false)

    const [ShowRpt, setShowRpt] = useState(false)

    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
 
    
    const [DataFormatValue, setDataFormatValue] = useState(false)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    //const [cPrintMode, setcPrintMode] = useState("PS")
    const [LineLimit, setLineLimit] = useState(54 - 7)
    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CBBCTranInfo>()
  
    const[File_Indicator,setFile_Indicator] = useState("")

    const[ResetFile_Indicator,setResetFile_Indicator] = useState("")

    const[RstByAppyDate,setRstByAppyDate]=  useState(utils.formatNumber(new Date()))

 
    const [MoblieDev, setMoblieDev] = useState(false)
 
    const [searchLimit, setSearchLimit] = useState(25)
    const [searchBackward, setSearchBackward] = useState(false)

    const [searchKey, setSearchKey] = useState("StkCode")
    const [searchValue, setSearchValue] = useState(CBBC.d_StkNo)
    const [showFilters, setShowFilters] = useState(false)
    const [data, setData] = useState([] as CBBCTranInfo[])
    const [currentAc, setCurrentAc] = useState({} as CBBCTranInfo)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [isResetPress, setisResetPress] = useState(false)
    const [s_StkNo1, sets_StkNo1] = useState("")
  

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    
    const [Enter2tab, setEnter2tab] = useState("Y")
    const history = useHistory()
    
    const [StkNoValue, setStkNoValue] = useState(CBBC.d_StkNo)
    const [StkCodeValue, setStkCodeValue] = useState("")
    const [StkNameValue, setStkNameValue] = useState("")
 
    const [CCASSStockValue, setCCASSStockValue] = useState(false)
    const [StkTypeValue,setStkTypeValue] = useState("")
    const [StkLotSizeValue,setStkLotSizeValue] = useState("")
    const [StkExpiryDateValue,setStkExpiryDateValue] = useState("")
    const [configData, setConfigData] = useState({} as sbConfig) 
    const [def_d_ResidualValue,setdef_d_ResidualValue] = useState("")
    const [def_d_HandlingFee,setdef_d_HandlingFee] = useState("0")
    const [def_d_MINHAND,setdef_d_MINHAND] = useState("0")
    const [def_d_MAXHAND,setdef_d_MAXHAND] = useState("0")      
     
    const [def_d_CAFEE,setdef_d_CAFEE] = useState("0")      
     
    const [def_d_CAMINFEE,setdef_d_CAMINFEE] = useState("0")      
      
    const [def_d_CAMAXFEE,setdef_d_CAMAXFEE] = useState("0")      
    const [def_d_Reason,setdef_d_Reason]   =  useState("")

    const [isNew,setrisNew] = useState(true)


    useEffect(() => {
        setRptName("")
        setShowRpt(false)        
        setShowNoRecord(false)     
        setShowOK(true)
    }, [CBBC.d_StkNo,DataFormatValue])

    useEffect(() => {
        if ( RptName !== "" && DataFormatValue ) {
            document.getElementById("_rptlink")?.click()
        }
    }, [RptName]) 

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onCBBCStlWithDrawal)()
        }
    }

  useEffect(() => {
        (async () => {
            try {
              
                 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: CBBC.d_StkNo})   
                 
                    //console.log("GetStkInfo=>",res.data.data)
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    //setStkNameValue(res.data.data[0].d_StkName)
                    //setCCASSStockValue(res.data.data[0].d_CcassStk==="Y")

                    setStkTypeValue(res.data.data[0].d_StkType)
                    setStkLotSizeValue(res.data.data[0].d_LotSize)
                    setStkExpiryDateValue(res.data.data[0].d_ExpiryDate)
                    //setShowOK(true)
                   
                    const res2 = await gsb.post('/Master',
                            {   sb_data: {
                                    by: "",
                                    start: "",
                                    nPage: 1,
                                    limit: 0,
                                    backward: false,
                                    SortByName: false,
                                            filters: {
                                    }
                                },
                                cPgmId: "GsbConfig",
                                cAction: "ListRec",
                            });
    
                 
                           

                        if (StkTypeValue==="W")
                        {
                           setdef_d_Reason("WARRANT")
                        }
                        else if (StkTypeValue ==="C")
                        {
                            setdef_d_Reason("CBBC")
                        }
                        else
                        {
                            setdef_d_Reason("PRIVATISATION")
                        }



                    
              
                
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [])

    useEffect(() => {
        (async () => {
            try {

                 setdef_d_HandlingFee(utils.numToString3(CBBC.d_HandlingFee))
              
        
    
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SmMastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SmMastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SmMastMain disp GsbFlag: ", GsbFlag)
                //console.log("SmMastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SmMastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                //console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                //console.log("SmMastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
                setEnter2tab(GsbFlag.Enter2tab) ;
                setCSVFormat(GsbFlag.CSVFormat) ;
               
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])
        
    useEffect(() => {
        const refreshTasks = async () => {
            ProgressId2 = ProgressId
            if ( ProgressId2.trim().length > 0 ) {
                try {
                    const res = await gsb.post('/Progresslist', {p_data: ProgressId2})
                    let pValue = 0
                    if ( res.data.count > 0 ) {
                        if ( res.data.data[0].id === ProgressId2 ) {
                            pValue = res.data.data[0].progressValue / res.data.data[0].progressMax
                            //console.log("Progresslist: ", res.data.data[0].progressValue, res.data.data[0].progressMax) 
                            //console.log("Progresslist pValue: ", pValue) 
                            setProgressValue(pValue)
                        }
                        if (res.data.data[0].status > 0 ) {
                            clearInterval(timer)
                        }
                    }
                } catch (error) {
                    utils.showError(error)
                }
            }
        }
        let timer = setInterval(refreshTasks, 20*1000)
        return () => {clearInterval(timer)}
    }, [gsb, ProgressId, nPage])
 
    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }
    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>




    useEffect(() => {
        if (taskList.findIndex((t: TaskInfo) => t.status === 0) > -1) {
            //console.log("running task(s) found, refresh tasklist in 1s")
            setTimeout(async () => {
                try {
                    const res = await gsb.post('/tasklist', taskList.map((t) => t.id));
                    //console.log("tasklist res.data.data", res.data.data)
                    setTaskList(res.data.data)
                } catch (error) {
                    utils.showError(error)
                }
            }, 3*1000)
        } else {
            //console.log("all task(s) completed.")
        }
    }, [taskList, gsb])

 
 
   
    const onCBBCStlWithDrawal = ( ) => {
       
        setShowOK(false);
        setShowOK(false)
        setShowWait(true)
        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")
        setRptNameNo(0)
        setnPage(1)
        ProgressId2 = utils.genUUID()
        setProgressId(ProgressId2)
        setProgressValue(0)
        //console.log("StkHoldMain onsubmit ProgressId: ", ProgressId2) 

        if ( utils.getDeviceType()) {
            //alert("MoblieDev")
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
         
        (async () => {
            try {
                const res = await gsb.post('/CBBC',
                    {   sb_data: {
                            ProgressId: ProgressId2,
                            s_PrintDetail: false,
                            s_StkNo1:CBBC.d_StkNo,                              
                            DataFormat: DataFormatValue,
                            nPage: 1,
                            cPrintMode: "PS",
                        },
                        cPgmId: "CBBCCallMgnt",    //CBBCCallMgnt
                        cAction: "CBBCStkWithDrawal"  //CBBCStkWithDrawal
                    });               

                if ( res.data.count > 0 ) {
                    setRstdata2([])
                    for (let j = 0; j < res.data.Rptdata.length; j++) {
                        Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                    }
                    setShowWait(false)
                    setShowNoRecord(false)
                    setShowRpt(true)
                    setRstdata(Rstdata2)
                    //console.log("Rstdata: ", Rstdata) 
                    setRptHead1(res.data.Rpthead1)
                    //setRptName(res.data.RptName)
                    //setRptNameNo(res.data.RptNameNo)
                    setRptLogName(res.data.RptLogName)
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(res.data.TotalPageNo)
                        for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                        if (res.data.RptNameNo > 0 ) {
                            for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                                aRptNameNo.push({n: j});
                            }
                            setRptName(res.data.RptName.replace(".pdf",""))
                        }
                    }
                } else {
                    setShowWait(false)
                    setShowNoRecord(true)
                    setShowRpt(false)
                }

              
            } catch (error) {
                utils.showError(error)
            }
        })()

      
    }

    let list1 = <>
        <div className="Spacing-V-16" />
        {/*RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>*/}
        &nbsp; &nbsp; {/*RptLogName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>*/}
        {ShowRpt && ! DataFormatValue && Pagination}
        {/* display search list */}
     
        {RptLogName.trim().length > 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>}
        <HTMLTable striped interactive condensed>
            <thead id="rpt_th_r">
               {/* <tr >
                    { ! DataFormatValue && <th className="RCol-Head_p">
                            {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
                        </th>
                    }
                </tr>*/}
                <tr>
                    <td className="RCol-Head1">{RptHead1}</td>
                </tr>                    
            </thead>
            <tbody id="rpt_tr">
                {Rstdata.map((rpt, i) =>
                    <tr key={i} onDoubleClick={() => { }}>
                        <td className="RCol-Rpt" onClick={() => {  }}>{rpt.Rst_Line}</td>
                    </tr>
                )}
            </tbody>
            <div className="Spacing-V-16" />
            {ShowRpt && ! DataFormatValue && Pagination}
        </HTMLTable>
    </>  


    let RptNameaRef = <>
    { RptNameNo > 0 && <div> Download / Print &nbsp;
        {aRptNameNo.map((no, j) => 
            <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptLogName}-${no.n}.pdf`}> <span id="RPageNo2" onClick={() => {} }> {no.n} &nbsp; </span> </a>
        )}
    </div> }
        {RptNameNo <= 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptLogName}`}>Download / Print </a>}
    </>
    let list = <>
    <div className="Spacing-V-8" />
        {/*RptLogName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptLogName}`}>Download / Print </a>*/}
        {/*RptLogName.trim().length > 0 && RptNameaRef*/}
    {/*ShowRpt && ! DataFormatValue && Pagination*/}
    {/* display search list */}
    <HTMLTable striped interactive condensed>
        <thead id="rpt_th_r">
            <tr >
                { ! DataFormatValue && <th className="RCol-Head_p">
                    {/* {RptLogName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptLogName}`}>Download / Print</a>} */}
                    {/*RptName.trim().length > 0 && RptNameaRef*/}
                </th>
                }
            </tr>                    
            <tr>
                <td className="RCol-Head1">{RptHead1}</td>
            </tr>                    
        </thead>
        <tbody id="rpt_tr">
                <tr ><td>Result:</td>
                </tr>            
            {Rstdata.map((rpt, i) =>

                <tr key={i}>
                    <td className="RCol-Rpt" >{rpt.Rst_Line}</td>
                </tr>
            )}
            <div className="Spacing-V-16" />
                {RptLogName.length > 0 && <tr><a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}> View log </a></tr>}
        </tbody>
        <div className="Spacing-V-16" />
          
        {/*ShowRpt && ! DataFormatValue && Pagination*/}
    </HTMLTable>
    </>
  let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>    

    return (     
        <form onKeyDown={handleHotkey}>
         
            <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        
                    </FormGroup>
                </div>     
           
               
                <div className="Spacing-V-16" />
                {/*<Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >  */}
                <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} > 
                <H3><div style={{ justifyContent: 'flex-end' }}>9C3 Called CBBC Stock Withdrawal ( {CBBC.d_StkNo} )
                        </div>

                    </H3> 
                
                    <div className="Row">

                      
                        <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                            <InputGroup disabled={! isNew} id="inputStkNo" name ="d_StkNo" value={StkNoValue}  defaultValue="" placeholder="Stock No. ..."  inputRef={register({ required: true}) } />
            
                        </FormGroup>
                     
                        <FormGroup className="Col-2-5" label="Stock Code / Name" labelFor="inputStkName">
                            <div>
                            <div id="DispText">{StkCodeValue}</div>
                            <div id="DispText">{StkNameValue}</div>
                            </div>
                        </FormGroup>

                        <FormGroup className="Col-1-2" label="Expiry Date" labelFor="inputStkExpiryDateValue" >                            
                            <InputGroup id="inputStkExpiryDateValue" readOnly name="StkExpiryDateValue"  defaultValue={StkExpiryDateValue}   />
                        </FormGroup> 

                        <FormGroup className="Col-3-2" label="Stock type." labelFor="inputStkTypeValue" >                            
                            <InputGroup id="inputStkTypeValue" readOnly name="StkTypeValue"  defaultValue={StkTypeValue}   />
                        </FormGroup> 
                        <FormGroup className="Col-1-2" label="Residual Value." labelFor="inputResidual">                            
                            <InputGroup id="inputd_ResidVal" readOnly name="d_ResidualValue"  defaultValue={utils.ParseFloat(CBBC.d_ResidualValue,2)}   />
                        </FormGroup>                         
                      <FormGroup className="Col-3-2" label="No of Client." labelFor="inputNOCLIENT">                            
                            <InputGroup id="inputd_ResidVal" readOnly name="d_NOCLIENT"  defaultValue={utils.numToString(CBBC.d_NOCLIENT)}   />
                        </FormGroup>    
                        <FormGroup className="Col-1-2" label="Handling Fee." labelFor="inputHandling">
                            <InputGroup id="inputd_ResidVal" readOnly name="d_HandlingFee"  defaultValue={utils.numToString3(CBBC.d_HandlingFee)}   onChange={(utils.handleStringChange(s => setdef_d_HandlingFee(s))) }     />
                        </FormGroup> 
                    <FormGroup className="Col-3-2" label="Minimum Handling Fee." labelFor="inputMINHAND">
                            <InputGroup  readOnly name="d_MINHAND"  defaultValue={utils.ParseFloat(CBBC.d_MINHAND,2)}  />
                        </FormGroup>        
                    <FormGroup className="Col-5-2" label="Maximum Handling Fee." labelFor="inputMAXHAND">
                            <InputGroup  readOnly name="d_MAXHAND" defaultValue={utils.ParseFloat(CBBC.d_MAXHAND,2)}   />
                        </FormGroup>     
        
                        <FormGroup className="Col-1-2" label="CA Fee." labelFor="inputCAFEE">
                            <InputGroup readOnly  name="d_CAFEE"  defaultValue={utils.ParseFloat(CBBC.d_CAFEE,2)}      />
                        </FormGroup>       
                            <FormGroup className="Col-3-2" label="Minimum CA Fee." labelFor="inputCAMINCAFEE">
                            <InputGroup  readOnly name="d_CAMINFEE"  defaultValue={utils.ParseFloat(CBBC.d_CAMINFEE,2)}    />
                        </FormGroup>        
                        <FormGroup className="Col-5-2" label="Maximum CA Fee." labelFor="inputdCAMAXCAFEE">
                            <InputGroup  readOnly name="d_CAMAXFEE"   defaultValue={utils.ParseFloat(CBBC.d_CAMAXFEE,2)}    />
                        </FormGroup>  


                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-2" >
                            <div>  Reason : {def_d_Reason}</div>
                        </FormGroup>
           
                    </div>

                <div className="Row">
                    <Button className="Col-1-2 Button-LabeledFormGroup" disabled={! ShowOK} onClick={() => onCBBCStlWithDrawal() } >Procress</Button> 
                </div>  
    
            {/*</Card>*/}
            <div className="Spacing-V-16" />
            </Card>
         
           
            
            {/* {ShowWait && <div>{imgWait}</div> } */}
            {ShowWait && <div className="TCol-Progress2">Progress ...</div> }
            {ShowWait && <div className="TCol-Progress2"><ProgressBar stripes={false} animate={false} value={ProgressValue} /></div> }
            {ShowNoRecord && <p>
                <div className="Spacing-V-16" />
                <div className="Row">
                    <FormGroup className="Col-1-3"  >
                        <span id="Err_msg">No Record found !!!</span>
                    </FormGroup>
                </div>
            </p>
            }
            {  list}
        </form>  
    )
}











function CBBCCallMgntView({ gsb, CBBCTran = {} as CBBCTranInfo,  CBBCTran0 = {} as CBBCTranInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { } }: CBBCCallMgntViewProps) {

    const { t, i18n } = useTranslation();   

    const [isDeletePress, setisDeletePress] = useState(false)

    const [isOpenDialog, setisOpenDialog] = useState(false)
    const [isOPenAlert, setisOPenAlert] = useState(false)
    const [cAction, setcAction] = useState("")
    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")


    const [PrevDayValue, setPrevDayValue] = useState(0)
    const [LatestBalValue, setLatestBalValue] = useState(0)
    const [UnClrChqValue, setUnClrChqValue] = useState(0)

 


    if (! ("d_StkNo" in CBBCTran)) return null

    
    return (
        <div>
            {/* define add,change,delete button */}
            <div className="Row">
                {/*<Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>*/}
                
                {/* <Button className="Col-2-1" icon="add" onClick={() => onNew()} >New</Button>
                <Button className="Col-3-1" icon="edit" onClick={() => onEdit()} >Edit</Button>
                <Button className="Col-4-1" icon="delete" onClick={() => onDelete()} >Delete</Button> */}
                {/*<Button className="Col-1-1" icon="add" onClick={() => onNew() } >New</Button>*/}
                {/*<Button className="Col-2-1" icon="edit" onClick={() => onEdit() } >Edit</Button>*/}
                {/*<Button className="Col-4-1" icon="delete" onClick={() => setisDeletePress(true)} >Delete</Button>*/}
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                {/*<Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>*/}
               {<Button className="Col-5-2" icon="document" onClick={() => { window.open(`/#/CBBCProcess?Stkno=${CBBCTran.d_StkNo}`, '_blank') } } >CBBC Process</Button>}
                {/*<Button className="Col-9-3" icon="document" onClick={() => { window.open(`/#/WarrantRightsProcess?Stkno=${CBBCTran.d_StkNo}?AnnouncementNo=${Announcement.d_AnnouncementNo}`, '_blank') } } >Bonus, Warrant, Rights, Split & Consolidation Process</Button>*/}
                {/* <Button className="Col-7-2" icon="document" onClick={() => { window.open(`/#/BookClosedQty?Stkno=${Announcement.d_StkNo}?AnnouncementNo=${CBBCTran.d_AnnouncementNo}`, '_blank') } } >Book Closed Qty</Button> */}
            </div>
            <div className="Spacing-V-16" />

            <div className="Row">
                <FormGroup className="Col-1-2" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                    <InputGroup readOnly value={CBBCTran.d_StkNo} />
                </FormGroup>
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{CBBCTran.d_Stk}</div>
                    <div id="DispText"></div>
                    </div>
                </FormGroup> 
                 <FormGroup className="Col-1-2" label="ExpiryDate." labelFor="inputExpiryDate">
                    <InputGroup readOnly value={CBBCTran.d_ExpiryDate} />
                </FormGroup>
                 <FormGroup className="Col-1-2" label="BotLot" labelFor="inputLotSize">
                    <InputGroup readOnly value={CBBCTran.d_LotSize} />
                </FormGroup>
                 <FormGroup className="Col-1-2" label="Residual Value." labelFor="inputResidual">
                    <InputGroup readOnly value={CBBCTran.d_ResidVal} />
                </FormGroup>   
                 <FormGroup className="Col-1-2" label="Handling Fee." labelFor="inputHandling">
                    <InputGroup readOnly value={utils.numToString3(CBBCTran.d_HandlingFee)} />
                </FormGroup>       
                <FormGroup className="Col-3-2" label="Minimum Handling Fee." labelFor="inputMINHAND">
                    <InputGroup readOnly value={utils.numToString3(CBBCTran.d_MINHAND)} />
                </FormGroup>        
                <FormGroup className="Col-5-2" label="Maximum Handling Fee." labelFor="inputMAXHAND">
                    <InputGroup readOnly value={utils.numToString3(CBBCTran.d_MAXHAND)} />
                </FormGroup>     

                <FormGroup className="Col-1-2" label="CA Fee." labelFor="inputCAFEE">
                    <InputGroup readOnly value={utils.numToString2(CBBCTran.d_CAFEE)} />
                </FormGroup>       
                 <FormGroup className="Col-3-2" label="Minimum CA Fee" labelFor="inputCAMAXCAFEE">
                    <InputGroup readOnly value={utils.numToString2(CBBCTran.d_CAMINFEE)} />
                </FormGroup>        
                <FormGroup className="Col-5-2" label="Maximum CA Fee" labelFor="inputdCAMAXCAFEE">
                    <InputGroup readOnly value={utils.numToString2(CBBCTran.d_CAMAXFEE)} />
                </FormGroup>       


                {/*<FormGroup className="Col-3-2" label="No of Client" labelFor="inputStkNo" labelInfo="*">
                    <InputGroup readOnly value={CBBCTran.d_NOCLIENT} />
                </FormGroup>*/}
 

 
            </div>

        </div>
    )
}

interface CBBCCallMgntEditProps {
    gsb: AxiosInstance,
    CBBCTran?: CBBCTranInfo,
    CurrencyList?: CurrencyInfo[],
    isNew?: boolean,
    onSave?: (stk: CBBCTranInfo) => void,
    onCancel?: () => void;
}

function CBBCCallMgntEdit({ gsb, CBBCTran = {} as CBBCTranInfo, CurrencyList=[] as CurrencyInfo[], isNew = false, onSave = () => { }, onCancel = () => { } }: CBBCCallMgntEditProps) {

      let ProgressId2 = ""

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<CBBCTranInfo>()

    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [ProgressId, setProgressId] = useState("")

    const [StkNoValue, setStkNoValue] = useState(CBBCTran.d_StkNo)
    const [Caretdown2, setCaretdown2] = useState(false)
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])
    const [StkCodeValue, setStkCodeValue] = useState(CBBCTran.d_Stk)
    const [StkNameValue, setStkNameValue] = useState(CBBCTran.d_StkName)
   // const [StlLotSzieValuem setStkLotSizeValue] = useState(CBBCTran.d_LotSize)
    const [CCASSStockValue, setCCASSStockValue] = useState(false)
    const [StkTypeValue,setStkTypeValue] = useState(CBBCTran.d_StkType)
    const [StkLotSizeValue,setStkLotSizeValue] = useState(CBBCTran.d_LotSize)
    const [StkExpiryDateValue,setStkExpiryDateValue] = useState(CBBCTran.d_ExpiryDate)
    
    const [ResidValue,setResidValue] = useState("0")
    const [def_HandlingFee,set_defHandlingFee] = useState("0")
    const [def_HandlingFeeMin,setdef_HandlingFeeMin] = useState ("0")
    const [def_HandlingFeeMax,setdef_HandlingFeeMax] = useState ("0")
    const [def_CAFee,setdef_CAFee] = useState("0")
    const [def_CAFeeMin,setdef_CAFeeMin] = useState ("0")
    const [def_CAFeeMax,setdef_CAFeeMax] = useState ("0")
    const [configData, setConfigData] = useState({} as sbConfig)


    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0") 


    
        const [ProgressValue, setProgressValue] = useState(0)
    
 
    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [ExecelFile,setExcelFile] =  useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)
    
    const [DataFormatValue, setDataFormatValue] = useState(true)
    const [CSVFormat, setCSVFormat] = useState("0")
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])

   
    useEffect(() => {
        // Call reset to get the values of record SmEntitInfo 
        if ("d_StkNo" in CBBCTran) {
            reset(CBBCTran)
        }
    }, [CBBCTran, reset])


/*
    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it (d_Market) manually and call setValue when item is selected
        register({ name: "d_Dividend_Currency" })
    }, [register])
*/

    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])



    useEffect(() => {
        (async () => {
            try {
                // get Stk Info
                //console.log("StkDepWithTranEntryEdit StkDepWith.d_acCode: ", StkDepWith.d_acCode, AcCodeValue) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: StkNoValue})
                //console.log("StkDepWithTranEntryEdit GetACInfo data : ", res.data.data) 
                //console.log("StkDepWithTranEntryEdit GetACInfo  count: ", res.data.count) 
                
                if ( StkNoValue.trim().length > 0 && res.data.count > 0 )
                {
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    setStkNameValue(res.data.data[0].d_StkName)
                    setCCASSStockValue(res.data.data[0].d_CcassStk==="Y")

                    setStkTypeValue(res.data.data[0].d_StkType)
                    setStkLotSizeValue(res.data.data[0].d_LotSize)
                    setStkExpiryDateValue(res.data.data[0].d_ExpiryDate)
 
                    const res2 = await gsb.post('/Master',
                            {   sb_data: {
                                    by: "",
                                    start: "",
                                    nPage: 1,
                                    limit: 0,
                                    backward: false,
                                    SortByName: false,
                                            filters: {
                                    }
                                },
                                cPgmId: "GsbConfig",
                                cAction: "ListRec",
                            });
                    //setConfigData(res2.data.data)                            
                   // console.log(res2.data.data)

                    if (isNew)
                    {
                        //console.log("isNew",isNew,"main res.data",isNew, res2.data.data[0])
                        //setConfigData(res2.data.data[0])
                        //setdefHandlingFee((configData))
                        //console.log(configData.x_CBBC_CAFEE)
                    
                    }
                    else
                    {
                        //setdef_HandlingFeeMax(utils.numToString3(CBBCTran.d_CAFEE))
                    }
                        //console.log(configData.x_CBBC_CAFEE)
                    
                } else { 
                    setStkCodeValue("")
                   // setStkNameValue("")
                    setCCASSStockValue(false)
                   // setMarketValue("")
                    //setFeeCodeValue("")
                    //setCurrencyValue("")
                }
               
            } catch (error) {
                //showErrorBox(error)
            }
        })()
    }, [gsb, StkNoValue])



    useEffect(() => {

 

        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,
                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "GsbConfig",
                        cAction: "ListRec",
                    });
               
                console.log(res.data.data)
                if (res.data.data.length > 0) {
                   // setCurrentAc(res.data.data[0])
                }
               
                //setdefHandlingFee("55")
                
              
                //console.log("main currentAc", currentAc)
                //setCurrentMode("show")

               // setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        (async () => {
            try {
                // get Stock Code List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "StkCodeList"})
                //console.log("StkCodeList: ", res.data.data) 
                setStkCodeList(res.data.data)
                //console.log("set StkCodeList: ", StkCodeList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    if (! isNew && ! ("d_StkNo" in CBBCTran)) return null


    let DescLength = 45
    if ( GsbFlag.LONG_DESC ) {
        DescLength = 60
    }
    
    const onSubmit = (data: CBBCTranInfo) => {
        data.d_StkNo = StkNoValue ;
       

        (async () => {
            try {
                const res = await gsb.post('/CBBC',
                {   sb_data:{  
                    ProgressId: "",
                    DataFormat : DataFormatValue,                                            
                    s_StkCode1:data.d_StkNo,   
                    s_Stk : data.d_Stk,
                    s_ResidualValue:data.d_ResidualValue,
                    s_HandlingFee:data.d_HandlingFee,
                    s_MINHAND:data.d_MINHAND,
                    s_MAXHAND:data.d_MAXHAND,
                    s_CAFEE:data.d_CAFEE,
                    s_CAMINFEE:data.d_CAMINFEE,
                    s_CAMAXCEE:data.d_CAMAXFEE,
                    },
                cPgmId: "CBBCCallMgnt",
                cAction: "CBBCGenerate"
            
                });
            } catch (error) {
                showErrorBox(error)
            }
        })()
 
        //onSave(data)
    }



    const CurrencyRenderer: ItemRenderer<CurrencyInfo> = (CurrencyList, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${CurrencyList.d_CcyDesc}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={CurrencyList.d_Currency}
                key={CurrencyList.d_Currency}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const CurrencyPredicate: ItemPredicate<CurrencyInfo> = (query, CurrencyList, _index, exactMatch) => {
        const normalizedText = `${CurrencyList.d_Currency} - ${CurrencyList.d_CcyDesc}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const CurrencyValueRenderer = (CurrencyList: CurrencyInfo) => {
        return CurrencyList.d_Currency
    }

    

    const StkRenderer: ItemRenderer<StkCodeInfo> = (stk, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${stk.d_StkCode}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={stk.d_StkNo}
                key={stk.d_StkNo}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const StkPredicate: ItemPredicate<StkCodeInfo> = (query, stk, _index, exactMatch) => {
        const normalizedText = `${stk.d_StkNo} - ${stk.d_StkCode}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const StkValueRenderer = (stk: StkCodeInfo) => {
        return stk.d_StkNo
    }


    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmit)()
        }
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }



    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} > 
            <div className="Row">
                {/*<Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>*/}
                {/*<Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Generate</Button>*/}

             </div>
            <div className="Spacing-V-16" />

             
            <div className="Row">
                { ! Caretdown2 && 
                    <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                        <InputGroup disabled={! isNew} id="inputStkNo" name ="d_StkNo" value={StkNoValue} autoFocus={isNew} defaultValue="" placeholder="Stock No. ..." onChange={utils.handleStringChange(s => setStkNoValue(s)) } inputRef={register({ required: true}) } />
                        {errors.d_StkNo && errors.d_StkNo.type === "required" && <span id="Err_msg">Stock No. cannot be Blank</span>}
                        {errors.d_StkNo && errors.d_StkNo.type === "maxLength" && <span id="Err_msg">Max length is 6</span>}
                        {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                    </FormGroup>
                }

                <FormGroup className="Col-2-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{StkCodeValue}</div>
                    <div id="DispText">{StkNameValue}</div>
                    </div>
                </FormGroup>


                <FormGroup className="Col-7-1" label="Stock Type" labelFor="inputStkName">
                     
                    <div id="DispText">{StkTypeValue}</div>
                    {/*<div id="DispText">{StkNameValue}</div>*/}
                   
                </FormGroup>
                {/* <span onClick={() => { setCaretdown2(!Caretdown2) } }> {imgCaretdown} </span> */}

                <FormGroup className="Col-1-1" label="Expiry Date" labelFor="inputStkExpiryDateValue">
                     
                    <div id="DispText">{StkExpiryDateValue}</div>                 
                   
                </FormGroup>
               <FormGroup className="Col-1-1" label="Board Lot" labelFor="inputStkLotSize">
                     
                    <div id="DispText">{StkLotSizeValue}</div>                 
                   
                </FormGroup>

       

                 <FormGroup className="Col-1-2" label="Residual Value." labelFor="inputResidual" labelInfo="*">
                   
                   <InputGroup id="inputd_ResidVal" name="d_ResidVal"    inputRef={register} />
                    {errors.d_ResidVal && errors.d_ResidVal.types && <span id="Err_msg">{errors.d_ResidVal.types.message}</span>}
                      
                </FormGroup>   
                 <FormGroup className="Col-1-2" label="Handling Fee." labelFor="inputHandling" labelInfo="*">
                    <InputGroup id="inputd_ResidVal" name="d_HandlingFee"  value={utils.numToString3(configData.x_CB_HAND)}  inputRef={register}/>
                </FormGroup>       
                 <FormGroup className="Col-3-2" label="Handling MIN Fee." labelFor="inputMINHAND" labelInfo="*">
                    <InputGroup   name="d_MINHAND" value={utils.numToString3(configData.x_CB_MINHAND)}  inputRef={register}/>
                </FormGroup>        
                <FormGroup className="Col-5-2" label="Handling MAX Fee." labelFor="inputMAXHAND" labelInfo="*">
                    <InputGroup   name="d_MAXHAND" value={utils.numToString3(configData.x_CB_MAXHAND)}  inputRef={register}/>
                </FormGroup>     

                <FormGroup className="Col-1-2" label="CA Fee." labelFor="inputCAFEE" labelInfo="*">
                    <InputGroup   name="d_CAFEE" value={utils.numToString2(configData.x_CBBC_CAFEE)}  inputRef={register}/>
                </FormGroup>       
                 <FormGroup className="Col-3-2" label="Minimum CA Fee." labelFor="inputCAMAXCAFEE" labelInfo="*">
                    <InputGroup   name="d_CAMINFEE" value={utils.numToString2(configData.x_CBBC_MINFEE)}  inputRef={register}/>
                </FormGroup>        
                    <FormGroup className="Col-5-2" label="Maximum CA Fee." labelFor="inputdCAMAXCAFEE" labelInfo="*">
                    <InputGroup  name="d_CAMAXFEE"  value={utils.numToString2(configData.x_CBBC_MAXFEE)}  inputRef={register}/>
                </FormGroup>  

                {<Button className="Col-1-2" icon="tick" onClick={handleSubmit(onSubmit)}>Generate</Button>}



            </div>
 
 
           </Card>
    
        
     
            
        </form>
    )
}
//CBBCCallMgntMainProps
interface CBBCStkWithDrawalMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function CBBCStkWithDrawalMain({ gsb }: CBBCStkWithDrawalMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { Stkno: defaultSearchValue = "" }: { Stkno: string } = useParams()
    let Stkno = utils.getUrlParameter('Stkno', url); 
    let Stkno2 = Stkno.substr(0,Stkno.indexOf("?")); 
    let AnnouncementNo = utils.getUrlParameter('AnnouncementNo', url); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 
/*
    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 
*/

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
   
    const [data, setData] = useState([] as CBBCTranInfo[])
    const [CurrencyList, setCurrencyList] = useState([] as CurrencyInfo[])
    const [CurrencyList2, setCurrencyList2] = useState([] as CurrencyInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchStkNo, setsearchStkNo] = useState("")
    const [searchChqPrintedStatus, setsearchChqPrintedStatus] = useState("")
    const [searchGeneratedStatus, setsearchGeneratedStatus] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    //const [currentTran, setcurrentTran] = useState({} as CBBCTranInfo)
    const [currentAc, setCurrentAc] = useState({} as CBBCTranInfo)
    const [BlankAc, setBlankAc] = useState({} as CBBCTranInfo)


    const [BlankAnnouncement, setBlankAnnouncement] = useState({} as CBBCTranInfo)

    const [currentMode, setcurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

    //const[ConfigData,setConfigData] =useState([] as sbConfig)
    const [SBConfigData, setSBConfigData] = useState([] as sbConfig[])
    
    const [Rstdata, setRstdata] = useState([] as RptRstInfo[])
    const [Rstdata2, setRstdata2] = useState([] as RptRstInfo[])
    const [RptHead1, setRptHead1] = useState("")
    const [RptName, setRptName] = useState("")
    const [ExecelFile,setExcelFile] =  useState("")
    const [RptNameNo, setRptNameNo] = useState(0)
    const [aRptNameNo, setaRptNameNo] = useState([] as PageInfo[])
    const [RptLogName, setRptLogName] = useState("")
    //const [ShowWait, setShowWait] = useState(false)
    const [ShowRpt, setShowRpt] = useState(false)
    const [ShowNoRecord, setShowNoRecord] = useState(false)
    const [ShowOK, setShowOK] = useState(true)

    const [ProgressValue, setProgressValue] = useState(0)

   const [DataFormatValue, setDataFormatValue] = useState(true)
    const [ViewMode, setViewMode] = useState("V")

  
  
    //BlankAc.d_StkNo = ""

    useEffect(() => {

        (async () => {
            try {
                const res = await gsb.post('/Master',
                    {   sb_data: {
                            by: "",
                            start: "",
                            nPage: 1,
                            limit: 0,

                            backward: false,
                            SortByName: false,
                                    filters: {
                            }
                        },
                        cPgmId: "GsbConfig",
                        cAction: "ListRec",

                    });
                setSBConfigData(res.data.data)
                if (res.data.data.length > 0) {
                   // setCurrentAc(res.data.data[0])
                }

                console.log("main res.data", res.data.data)
                //console.log("main currentAc", currentAc)
                //setCurrentMode("show")

               // setshowButton(false)

            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    BlankAc.d_StkNo = ""
    useEffect(() => {
        if (RptName !== "" && DataFormatValue) {
            document.getElementById("_rptlink")?.click()
        }
    }, [RptName]) 

    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                GsbFlag = res.data.Flag;
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) 
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


 

    useEffect(() => {
        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }

        (async () => {
            try {
                if ( Stkno2.trim().length > 0 && AnnouncementNo.trim().length > 0 ) {
                    setsearchStkNo(Stkno2)
                    const res = await gsb.post('/CBBC',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            processCBBCMgntGet: 1,
                            limit: m_limit,
                            backward: searchBackward,
                           // filters: {
                           //     s_StkNo: Stkno2,
                           //     s_ChqPrintedStatus: "",
                           //     s_GeneratedStatus: "",
                           // }, 
                        },
                        cPgmId: "CBBCCallMgnt",
                        cAction: "ListRec",
                    });

                    console.log("onSubmit res.data.data", res.data.data)
                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        for (let i = 0; i < res.data.data.length; i++) {
                            if (res.data.data[i].d_StkNo+res.data.data[i].d_StkNo === Stkno2+AnnouncementNo) {
                                setCurrentAc(res.data.data[i])
                                setSelectedTabId("detail") 
                                setcurrentMode("show")
                                break
                            }
                        }
                    }
                    
                    if ( res.data.count > 0 ) {
                        const aPageNumber1 = []
                        if ( res.data.count > 0 ) {
                            setnTotalPage(Math.ceil(res.data.count / searchLimit))
                            for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                                aPageNumber1.push({n: j});
                            }
                            setaPageNumber(aPageNumber1)
                        }
                    }
                }
                setShowWait(false);
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, Stkno2, AnnouncementNo])

    
    const PrevRecProcess = async (CBBCTran: CBBCTranInfo) => {
        try {
            //console.log("call PrevRecProcess", Announcement)
            const res = await gsb.post('/CBBC', {sb_data: CBBCTran, cPgmId: "CBBCCallMgnt", cAction: "PrevRec"})
           // console.log("PrevRecProcess show 1: ", stk.d_StkNo)
            console.log("PrevRecProcess data : ", data)
            console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo+data[i].d_acCode === data[i].d_StkNo+data[i].d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setCurrentAc(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setcurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (CBBCTran: CBBCTranInfo) => {
        try {
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/CBBC', {sb_data: CBBCTran, cPgmId: "CBBCCallMgnt", cAction: "DelRec"})
            showSuccess("Stock No. " + CBBCTran.d_StkNo+","+CBBCTran.d_Stk + " record deleted")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo+data[i].d_acCode === data[i].d_StkNo+data[i].d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setcurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (CBBCTran: CBBCTranInfo) => {
        try {
            //console.log("call NextRecProcess", Announcement)
            const res = await gsb.post('/CBBC', {sb_data: CBBCTran, cPgmId: "CBBCCallMgnt", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo+data[i].d_acCode === data[i].d_StkNo+data[i].d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setcurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (CBBCTran: CBBCTranInfo) => {
        try {
            //console.log("call newOnSave", Announcement)
            const res = await gsb.post('/CBBC', {sb_data: CBBCTran, cPgmId: "CBBCCallMgnt", cAction: "AddRec"})
            showSuccess("Stock No. " + CBBCTran.d_StkNo+","+CBBCTran.d_Stk + " record added")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo+data[i].d_acCode === data[i].d_StkNo+data[i].d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setcurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (Announcement: CBBCTranInfo) => {
        try {
            //console.log("call editOnSave", Announcement)
            const res = await gsb.post('/Dividend', {sb_data: Announcement, cPgmId: "StockAnnouncement", cAction: "UpdateRec"})
            showSuccess("Stock No. " + Announcement.d_StkNo+","+Announcement.d_Stk + " record saved")
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo+data[i].d_acCode === data[i].d_StkNo+data[i].d_acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    //console.log("editOnSave data", i, data)
                    setData(data)
                    //setCurrentStk(stk)
                    break
                }
            }
            //console.log("editOnSave stk", stk)
            //console.log("editOnSave res.data.data", res.data.data)
            setCurrentAc(res.data.data)
            setcurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const CBBC_Generate = async (sb_data: CBBCTranInfo) => {
        try {
            setShowOK(false)
            setShowWait(true)
            setShowNoRecord(false)
            setShowRpt(false)
            setRstdata([])
            setRptHead1("")
            setRptName("")            
            setExcelFile("")
            setRptLogName("")
            setnPage(1)    
            setProgressValue(0)

            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
            const res = await gsb.post('/CBBC',
                    {   sb_data:sb_data,                        
                        cPgmId: "CBBCMgnt", 
                        cAction: "CBBCGenerate"
                    }
                )

            console.log(res.data)
            if ( res.data.count > 0 ) {
                setRstdata2([])
                for (let j = 0; j < res.data.Rptdata.length; j++) {
                    Rstdata2.push({Rst_Key: res.data.Rptdata[j][0], Rst_Line: res.data.Rptdata[j][1]})
                }
                setShowWait(false)
                setShowNoRecord(false)
                setShowRpt(true)
                setRstdata(Rstdata2)
                console.log("Rstdata: ", Rstdata) 
                setRptHead1(res.data.Rpthead1)
                setRptName(res.data.RptName)
               // setExcelFile(res.data.ExecelFile)
            
                setRptLogName(res.data.RptLogName)
                setRptNameNo(res.data.RptNameNo)
                console.log("RptName: ", RptName) 
                const aPageNumber1 = []
                if ( res.data.count > 0 ) {
                    setnTotalPage(res.data.TotalPageNo)
                    for ( let j = 1; j <= res.data.TotalPageNo; j++ ) {
                        aPageNumber1.push({n: j});
                    }
                    setaPageNumber(aPageNumber1)
                    if (res.data.RptNameNo > 0 ) {
                        for ( let j = 1 ; j <= res.data.RptNameNo; j++ ){
                            aRptNameNo.push({n: j});
                        }
                        setRptName(res.data.RptName.replace(".pdf",""))
                    }
                }
            } else {
                setShowWait(false)
                setShowNoRecord(true)
                setShowRpt(false)
            }
            //  setData(data)
            //  setCurrentAc(res.data.data)
            //  setcurrentMode("show")
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }


    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)

        setShowNoRecord(false)
        setShowRpt(false)
        setRstdata([])
        setRptHead1("")
        setRptName("")        
        setExcelFile("")
        setRptLogName("")

        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get StockAnnouncementEntry list if StkNo have value
        try {
           
            if ( m_limit > 1 ) {
                const res = await gsb.post('/CBBC',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        //filters: {
                       //     s_StkNo: searchStkNo,
                        //    s_ChqPrintedStatus: searchChqPrintedStatus,
                        //    s_GeneratedStatus: searchGeneratedStatus,
                       // }, 
                    },
                    cPgmId: "CBBCCallMgnt",
                    cAction: "ListRec",
                });

                console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                /*
                const res = await gsb.post('/CBBC',
                {   sb_data: {
                        d_StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "CBBCCallMgnt",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    console.log("GetRec res.data.data", res.data.data)
                    setCurrentAc(res.data.data)
                    setcurrentMode("show")
                } else {
                    alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }*/
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one StockAnnouncementEntry record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                
                const res = await gsb.post('/CBBC',
                    {   sb_data: {
                            by: "StkNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "CBBCCallMgnt",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setCurrentAc(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/CBBC',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                s_StkNo: searchStkNo,
                               // s_ChqPrintedStatus: searchChqPrintedStatus,
                               //s_GeneratedStatus: searchGeneratedStatus,
                            }, 
                        },
                        cPgmId: "CBBCCallMgnt",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentAc(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }
//  let detail =<IPOMastExport gsb={gsb} IPO={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')}  ViewMode={ViewMode} logKey2={logKey2.trim()} ></IPOMastExport>
   

    // currentMode = show
   // let detail = <CBBCCallMgntView gsb={gsb} CBBCTran={currentAc} CBBCTran0={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentAc)} onNew={() => setcurrentMode("new")} onEdit={() => setcurrentMode("edit")} onDelete={() => DeleteProcess(currentAc)} onNextRec={() => NextRecProcess(currentAc)} ></CBBCCallMgntView>

   //let  detail = <CBBCCallMgntEdit gsb={gsb} CBBCTran={currentAc} CurrencyList={CurrencyList} isNew onSave={newOnSave} onCancel={() => { setcurrentMode("show"); setSelectedTabId("detail") } } ></CBBCCallMgntEdit>
   // switch (currentMode) {
        //case "PrevRec":
        // ?? will call 2 times ??
        //    console.log("currentMode = PrevRec")
        //    PrevRecProcess(currentStk)
        //    break
    //    case "new":
            //console.log("currentMode = new")
    //        detail = <CBBCCallMgntEdit gsb={gsb} CBBCTran={BlankAc} CurrencyList={CurrencyList} isNew onSave={newOnSave} onCancel={() => { setcurrentMode("show"); setSelectedTabId("detail") } } ></CBBCCallMgntEdit>
    //        break
    //    case "edit":
            //console.log("currentMode = edit")
    //        detail = <CBBCCallMgntEdit gsb={gsb} CBBCTran={currentAc} CurrencyList={CurrencyList} onSave={editOnSave} onCancel={() => setcurrentMode("show")} ></CBBCCallMgntEdit>
    //        break
        //case "delete":
        //    console.log("currentMode = delete")
        //    DeleteProcess(currentStk)
        //    break
     //   }

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let detail =< CBBCStockHolderList gsb={gsb} CBBC={currentAc} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')}  ViewMode={ViewMode} logKey2={logKey2.trim()} ></ CBBCStockHolderList>
   

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        {/*<div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setcurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>*/}
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-StkNo">Stock No</th>
                <th className="TCol-StkNo">Stock Name</th>              
                <th className="TCol-StkNo">Residual Value</th>     
                <th className="TCol-StkNo">Handling Fee</th>
                <th className="TCol-StkNo">Minimum Handling Fee</th>
                <th className="TCol-StkNo">Maximum Handling Fee</th>                
                <th className="TCol-StkNo">CA Fee</th>              
                <th className="TCol-StkNo">Minimum CA Fee</th>   
                <th className="TCol-StkNo">Maximum CA Fee</th>                                         
                <th className="TCol-StkNo">Stamp Amount</th>  
                <th className="TCol-StkNo">No of Client</th>  
                <th className="TCol-StkNo">Gen Withdrawal</th>
                <th className="TCol-StkNo">Gen P/R</th>                
             
            </thead>
         
            <tbody id="ma_tr">
               
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => {setSelectedTabId("detail")  }}>

                        {/*<td className="TCol-ACCode" onClick={() => { setCurrentAc(ac)  }}>{ac.d_acCode}</td>*/}

                         <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail")  }}>{ac.d_StkNo}</td> 
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail")}}>{ac.d_Stk}</td>                 
                        {/*<td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  }}>{ac.d_acCode}</td>*/}
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_ResidualValue}</td>            
                        {/*<td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  }}>{ac.d_acResidVal}</td> */}
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_HandlingFee}</td>   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac); MoblieDev && setSelectedTabId("detail") }}>{ac.d_MINHAND}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac); MoblieDev && setSelectedTabId("detail") }}>{ac.d_MAXHAND}</td>  
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail")  }}>{ac.d_CAFEE}</td>   
         
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail")  }}>{ac.d_CAMINFEE}</td>   
                            <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_CAMAXFEE}</td>   
                   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_STMVAL}</td>   
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  ; MoblieDev && setSelectedTabId("detail") }}>{ac.d_NOCLIENT}</td>   


                        {/*<td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  }}>{ac.d_BankCode}</td>*/}
                        {/*<td className="TCol-StkNo" onClick={() => { setCurrentAc(ac)  }}>{ac.d_ChqNo}</td>*/}
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac) ; MoblieDev && setSelectedTabId("detail")  }}>{ac.d_StkWDF==='2'?<Icon icon='tick'/>:<Icon icon ='cross' />}</td>
                        <td className="TCol-StkNo" onClick={() => { setCurrentAc(ac); MoblieDev && setSelectedTabId("detail") }}>{ac.d_StkPRF === '2' ? <Icon icon='tick' /> : <Icon icon='cross' />}</td>

                    </tr>
                )}                
                
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>
{/*
    let list2 = <>
        <div className="Spacing-V-16" />
      
        &nbsp; &nbsp; {RptName.trim().length > 0 && <a id="_rptlink" target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/logdownload?filename=${RptLogName}&inline`}>View Log</a>}
        {ShowRpt && ! DataFormatValue && Pagination}
   
        <HTMLTable striped interactive condensed>
            <thead id="rpt_th_r">
                <tr >
                    { ! DataFormatValue && <th className="RCol-Head_p">
                            {RptName.trim().length > 0 && <a target="_blank" rel="noopener noreferrer" href={`${gsb.defaults.baseURL}/Rptdownload?filename=${RptName}`}>Download</a>}
                        </th>
                    }
                </tr>                    
                <tr>
                    <td className="RCol-Head1">{RptHead1}</td>
                </tr>                    
            </thead>
            <tbody id="rpt_tr">
                {Rstdata.map((rpt, i) =>
                    <tr key={i} onDoubleClick={() => { }}>
                        <td className="RCol-Rpt" onClick={() => {  }}>{rpt.Rst_Line}</td>
                    </tr>
                )}
            </tbody>
            <div className="Spacing-V-16" />
            {ShowRpt && ! DataFormatValue && Pagination}
        </HTMLTable>
    </>*/}

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>
    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                    { ! ( logviewonly === "Y" ) &&  (selectedTabId ==="list") && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>9C3 Called CBBC Stock Withdrawal</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="StkNo">Stock No</option>
                                    {/* <option value="StkCode">Stock Code</option> */}
                                    {/* <option value="AnnouncementkNo">Announcement No</option> */}
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={( ! (searchKey == "StkNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={( ! (searchKey == "StkNo"))} type="submit" >{"List"}</Button>
                       {/*<Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}

                       
                    </div>
                    {/*<Collapse isOpen={showFilters}>
                        <div className="Row">
                         
                            <FormGroup className="Col-1-1" label="Stock No." labelFor="searchStkNo">
                                <InputGroup id="searchStkNo" value={searchStkNo} onChange={utils.handleStringChange(s => setsearchStkNo(s))} />
                            </FormGroup>
                            <FormGroup className="Col3-2-1" label="Cheque Printed" labelFor="searchChqPrintedStatus">
                                <select  id="searchConsent" value={searchChqPrintedStatus} onChange={utils.handleStringChange(s => setsearchChqPrintedStatus(s))}>
                                    <option value=""> </option>
                                    <option value="0">0 = not yet done</option>
                                    <option value="2">2 = Printeed</option>
                                </select>
                            </FormGroup>       
                            <FormGroup className="Col3-3-1" label="Generated" labelFor="searchGeneratedStatus">
                                <select  id="searchGeneratedStatus" value={searchGeneratedStatus} onChange={utils.handleStringChange(s => setsearchGeneratedStatus(s))}>
                                    <option value=""> </option>
                                    <option value="0">0 = not yet done</option>
                                    <option value="2">2 = Generated (Finished)</option>
                                </select>
                            </FormGroup>       
                        </div>
                    </Collapse>*/}
                        {list}
                </Card>  }
                { (selectedTabId ==="detail") && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                <div className="No-Screen" style={{justifyContent: 'flex-end'}}>HKIDR IPO Master</div>

                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="Back" panel={list} />                                      
                    </Tabs>
                    {detail}
                </Card> }

 

                {/*
                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
                    */}
            </form>
        </>
    );
}

export default CBBCStkWithDrawalMain